import { render, staticRenderFns } from "./SettingIntroBanner.vue?vue&type=template&id=c1fad788&scoped=true"
import script from "./SettingIntroBanner.vue?vue&type=script&lang=js"
export * from "./SettingIntroBanner.vue?vue&type=script&lang=js"
import style0 from "./SettingIntroBanner.vue?vue&type=style&index=0&id=c1fad788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fad788",
  null
  
)

export default component.exports